export enum FilterCategory {
  TAB,
  REGULAR,
}

export enum FilterValueType {
  string = "string",
  number = "number",
  boolean = "boolean",
  array = "array",
}

export type ScopeOptions = "tickers" | "profits";

export type FilterCatalogItem = {
  name: string;
  type: FilterValueType;
  displayName: string;
  mandatory?: boolean;
  icon: any;
  scopes: ScopeOptions[];
  remoteSyncScopes?: ScopeOptions[];
  defaultValue?: any;
};

export type FilterCatalogByName = Record<
  FilterCatalogItem["name"],
  FilterCatalogItem
>;

export type FilterValue = boolean | number | string | string[];

export type ActiveFiltersByName = Record<
  FilterCatalogItem["name"],
  FilterValue
>;
